var map = {
	"./canva-list.svg": "7487",
	"./custom-asset-list.svg": "d084",
	"./google-sheet-list.svg": "667f",
	"./google-slide-list.svg": "82a6",
	"./icon-clone-list.svg": "157d",
	"./instagram-list.svg": "8f58",
	"./loop-delete-list.svg": "5276",
	"./loop-edit-list.svg": "702c",
	"./loop-preview-list.svg": "821e",
	"./loop-setting-list.svg": "ec6e",
	"./pdf-list.svg": "cc92",
	"./share-edit-list.svg": "ef7c",
	"./weather-list.svg": "2c61",
	"./web-list.svg": "6559",
	"./youtube-list.svg": "cea7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "878a";